import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';

const Forward: FC<IIconsProps> = ({ color, size }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size || 16}
      height={size || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.12224 7.72895L9.12301 7.72973L4.45215 12.4005L3.11999 11.0684L6.45948 7.72895L3.12319 4.39269L4.45534 3.06055L9.12301 7.72818L9.12224 7.72895Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1 3.12035L10.1 12.3604L12 12.3604L12 3.12035L10.1 3.12035Z"
        fill={color}
      />
    </svg>
  );
};

export default Forward;
